import React, { useState, useEffect } from "react";
import { Table, Input, Select, Button, Tag } from "antd";
const { Option } = Select;
import "./assessmentPage.css";
import { allUsersApi, sendAllSpecificUsers } from "../../api/api";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";
import { addAssessmentsAPI } from "../../api/api";
import { Modal, DatePicker } from "antd";
import LoadingSpiner from "../Common/LoadingSpiner";

export default function SendTest({
  isVisible,
  setIsVisible,
  selectedTemplate,
}) {
  const token = localStorage.getItem("token");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [data, setData] = useState([]);
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [currentTest, setCurrentTest] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [tags, setTags] = useState([]);
  const [assignedDate, setAssignedDate] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [modalStep, setModalStep] = useState(1);
  const MemoizedTable = React.memo(Table);

  useEffect(() => {
    if (token) {
      setTags(["Example Tag 1", "Example Tag 2", "Example Tag 3"]);
      fetchData();
    }
  }, [token]);

  const handlePlusButtonClick = (item) => {
    if (!selectedRows.some((row) => row.user._id === item.user._id)) {
      setSelectedRows([...selectedRows, item]);
    }
  };

  const handleCancelButtonClick = (item) => {
    const updatedSelectedRows = selectedRows.filter(
      (row) => row.user._id !== item.user._id
    );
    setSelectedRows(updatedSelectedRows);
  };

  const handleTagAddClick = (item) => {
    if (!selectedTags.some((tag) => tag === item)) {
      setSelectedTags([...selectedTags, item]);
    }
  };

  const fetchData = async () => {
    const res = await allUsersApi();
    if (res) {
      const newData = res.map((data) => {
        const { user } = data;

        return {
          ...data,
          user: {
            ...user,
          },
        };
      });

      setData(newData);
      setFilteredData(newData);
      setLoading(false);
    }
  };

  const handleOk = async (test) => {
    const userIds = selectedRows.map((row) => row.user._id);
    if (assignedDate) {
      try {
        await sendAllSpecificUsers({
          users: userIds,
          templateId: selectedTemplate._id,
          status: "Assigned",
          assignedDate: assignedDate,
          dueDate: dueDate,
        });
      } catch (error) {
        console.error("Failed to assign test:", error);
      }
    }
    setIsVisible(false);
  };

  const handleAddAllClick = () => {
    const newSelectedRows = [...selectedRows];

    // Filter out already selected rows
    const filteredNewRows = filteredData.filter(
      (item) => !newSelectedRows.some((row) => row.user._id === item.user._id)
    );

    // Add all filtered data to selectedRows
    setSelectedRows([...newSelectedRows, ...filteredNewRows]);
  };

  const handleRemoveAllClick = () => {
    setSelectedRows([]);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: ["user", "name"],
      key: "name",
      responsive: ["sm", "md", "lg", "xl"],
      render: (name) => <h4 className="text-[15px]">{name}</h4>,
    },
    {
      title: "Age",
      dataIndex: ["user", "age"],
      key: "age",
      render: (title) => <h4 className="text-[15px]">{title}</h4>,
    },
    {
      title: "Gender",
      dataIndex: ["user", "gender"],
      key: "gender",
      render: (title) => <h4 className="text-[15px]">{title}</h4>,
      responsive: ["sm"],
    },
    {
      title: "AuditC",
      dataIndex: ["user", "auditC"],
      key: "auditCauditC",
      render: (title) => <h4 className="text-[15px]">{title}</h4>,
      responsive: ["sm"],
    },
    {
      title: (
        <Button
          type="primary"
          onClick={handleAddAllClick}
          style={{
            backgroundColor: "transparent",
            borderColor: "#1890ff",
            color: "#1890ff",
          }}
        >
          Add All
        </Button>
      ),
      dataIndex: ["user", "auditC"],
      key: "action",
      render: (text, record) => (
        <div style={{ display: "flex" }}>
          <p
            style={{
              fontSize: "10px",
              paddingRight: "10px",
              paddingTop: "10px",
              color: "#BBBBBB",
            }}
          >
            Add to send list
          </p>
          <Button
            type="primary"
            shape="circle"
            icon={<PlusOutlined />}
            style={{
              backgroundColor: "#6434FF",
              alignSelf: "center",
            }}
            onClick={() => handlePlusButtonClick(record)}
          />
        </div>
      ),
      responsive: ["sm"],
    },
  ];

  const addedColumns = [
    {
      title: "Name",
      dataIndex: ["user", "name"],
      key: "name",
      responsive: ["sm", "md", "lg", "xl"],
      render: (name) => <h4 className="text-[15px]">{name}</h4>,
    },
    {
      title: (
        <Button
          type="primary"
          onClick={handleRemoveAllClick}
          style={{
            backgroundColor: "transparent", // Ensure the button is always blue
            borderColor: "#1890ff",
            color: "#1890ff",
          }}
        >
          Remove All
        </Button>
      ),
      dataIndex: ["user", "auditC"],
      key: "action",
      render: (text, record) => (
        <div style={{ display: "flex" }}>
          <p
            style={{
              fontSize: "10px",
              paddingRight: "10px",
              paddingTop: "10px",
              color: "#BBBBBB",
            }}
          >
            Remove from list
          </p>
          <Button
            type="primary"
            shape="circle"
            icon={<CloseOutlined />}
            style={{
              backgroundColor: "#6434FF",
              alignSelf: "center",
            }}
            onClick={() => handleCancelButtonClick(record)}
          />
        </div>
      ),
      responsive: ["sm"],
    },
  ];

  const renderModalContent = () => {
    switch (modalStep) {
      case 1:
        return (
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <div style={{ backgroundColor: "white", width: "90%" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    borderColor: "black",
                    borderWidth: "1px",
                    width: "100%",
                    padding: "0px",
                    borderRadius: "50px",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      margin: 16,
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    {selectedTags.map((tag, index) => (
                      <Tag key={index} closable>
                        {tag}
                      </Tag>
                    ))}
                  </div>
                  <Input
                    placeholder="Type in patient name or filter by tags"
                    value={searchText}
                    onChange={onSearch}
                    style={{
                      margin: 16,
                      width: "100%",
                      float: "left",
                      border: "transparent",
                    }}
                  />
                </div>
              </div>
              <div
                style={{ margin: 16, display: "flex", flexDirection: "row" }}
              >
                {tags.map((tag, index) => (
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <Tag key={index}>
                      {tag}{" "}
                      <button onClick={() => handleTagAddClick(tag)}>+</button>
                    </Tag>
                  </div>
                ))}
              </div>
              <MemoizedTable
                columns={columns}
                dataSource={filteredData}
                pagination={{ pageSize: 10 }}
                rowKey={(record) => record._id}
              />
            </div>
            <div style={{ width: "50%", paddingLeft: "20px" }}>
              <Table
                columns={addedColumns}
                dataSource={selectedRows}
                pagination={false}
                rowKey={(record) => record.user._id}
                locale={{ emptyText: "Add patients to fill table" }}
              />
            </div>
          </div>
        );
      case 2:
        return (
          <div>
            <p style={{ margin: "10px" }}>
              Send this assessment to all selected users at once.
            </p>
            <div style={{ display: "flex" }}>
              <DatePicker
                onChange={setAssignedDate}
                style={{ marginRight: "20px", width: "170px" }}
                placeholder="Assignment Date"
              />
              <DatePicker onChange={setDueDate} placeholder="Due Date" />
            </div>
          </div>
        );
      default:
        return null;
    }
  };
  const renderModal = () => {
    return (
      <Modal
        title="Send Selected Assessment"
        open={isVisible}
        onCancel={() => {
          setIsVisible(false);
          setModalStep(1);
        }}
        width={1200}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setIsVisible(false);
              setModalStep(1);
            }}
          >
            Cancel
          </Button>,
          modalStep > 1 && (
            <Button key="back" onClick={() => setModalStep(modalStep - 1)}>
              Back
            </Button>
          ),
          <Button
            key="submit"
            className="blue-button"
            onClick={modalStep === 1 ? () => setModalStep(2) : handleOk}
          >
            {modalStep === 1 ? "Next" : "Send"}
          </Button>,
        ]}
      >
        {renderModalContent()}
      </Modal>
    );
  };

  const onSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);
    if (data !== undefined) {
      const newFilteredData = data.filter((entry) =>
        entry.user.name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredData(newFilteredData);
    }
  };

  if (loading) {
    return <LoadingSpiner loading={loading} />;
  }

  return <div>{renderModal()}</div>;
}
